function getCustomerStats (featureCollection) {
  console.log({ featureCollection })
  const stats = featureCollection.features.reduce(
    (acc, feature) => {
      acc.totalCustomers += 1
      acc.totalOrders += feature.properties.total_orders
      acc.totalSpent += feature.properties.total_spent
      return acc
    },
    { totalCustomers: 0, totalOrders: 0, totalSpent: 0 }
  )
  return stats
}
export {
  getCustomerStats
}
